<template>
  <div class="container">
    <div class="tool-nav">
      <ul class="dlds">
        <li
          @click="toPageDistrict(item)"
          v-for="(item, index) in menunameDetail.menuname"
          :key="item.index"
        >
          <a href="javascript:;" v-if="item == '云游库'">
            <img
              v-if="name != 'District'"
              src="@/assets/images/menu/yunto.png"
            />
            <img v-else src="@/assets/images/menu/yunto1.png" />
          </a>
          <a href="javascript:;" v-if="item == '地图'">
            <img
              v-if="region_type == 5 ? name != 'GuideH5' : name != 'Map'"
              src="@/assets/images/menu/map1.png"
            />
            <img v-else src="@/assets/images/menu/map.png" />
          </a>
          <a href="javascript:;" v-if="item == '攻略'">
            <img
              v-if="name != 'StrategyPage'"
              src="@/assets/images/menu/articel1.png"
            />
            <img v-else src="@/assets/images/menu/articel.png" />
          </a>
          <a href="javascript:;" v-if="item == '视频'">
            <img
              v-if="name != 'VideoPage'"
              src="@/assets/images/menu/video1.png"
            />
            <img v-else src="@/assets/images/menu/video.png" />
          </a>
          <a href="javascript:;" v-if="item == '图集'">
            <img v-if="name != 'Atlas'" src="@/assets/images/menu/image1.png" />
            <img v-else src="@/assets/images/menu/image.png" />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { menuname } from "@/api/travel";
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      name: "",
      gonglueurl: "javascript:;",
      menunameDetail: JSON.parse(localStorage.getItem("tabbarDetail")) || {},
      pageNmae: "",
      searchRoute: [],
      pinyin: "",
      region_type: JSON.parse(localStorage.getItem("region_type")) || 3,
    };
  },
  props: {
    isflag: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  computed: {
    ...mapState(["tabbarFlag"]),
    region: {
      get() {
        return this.$store.state.region;
      },
    },
  },
  components: {},
  mounted: function () {
    this.name = this.$route.name;
  },
  created() {
    this.pinyin = this.$route.params.pinyin
      ? this.$route.params.pinyin
      : JSON.parse(localStorage.getItem("regionList")).RegionEnName;
    if (this.tabbarFlag && this.isflag) {
      // console.log(this.$route);
      menuname({
        pinyin: this.pinyin,
        id: this.$route.params.id,
      }).then((res) => {
        this.$emit("flags", res.region_type);
        let arr = res.menuname;
        this.menunameDetail = res.menuname;
        this.set_TabbarFlag(false);
        localStorage.setItem("tabbarDetail", JSON.stringify(arr));
        localStorage.setItem("region_type", res.region_type);
        // 只要查不到该tabbar的值就默认返回到主页
        this.menunameDetail.menuname.forEach((v) => {
          if (v == "云游库") {
            this.searchRoute.push("District");
          } else if (v == "地图") {
            this.searchRoute.push("Map");
          } else if (v == "攻略") {
            this.searchRoute.push("StrategyPage");
          } else if (v == "视频") {
            this.searchRoute.push("VideoPage");
          } else if (v == "图集") {
            this.searchRoute.push("Atlas");
          }
        });
        //判断能不能找到，如果找不到就返回到首页，类似于路由拦截
        if (
          this.searchRoute.indexOf(this.$route.name) == -1 &&
          this.$route.name != "RecommandList" &&
          this.$route.name != "TravelList" &&
          this.$route.name != "Line" &&
          this.$route.name != "Competition" &&
          this.$route.name != "Celebration" &&
          this.$route.name != "Guide" &&
          this.$route.name != "GuideH5"
        ) {
          this.$router.push({
            name: "District",
            params: {
              id: this.$route.params.id,
              pinyin: this.pinyin,
            },
          });
        }
      });
    }
  },
  methods: {
    ...mapMutations(["set_TabbarFlag"]),
    jianshes() {
      if (this.region.isGonglue !== 1) {
        this.$toast("正在建设中。。");
      }
    },
    toPageDistrict(item) {
      const region_type = localStorage.getItem("region_type");
      if (item == "云游库") {
        this.pageNmae = "District";
      } else if (item == "地图") {
        if (region_type == 5) {
          this.pageNmae = "GuideH5";
        } else {
          this.pageNmae = "Map";
        }
      } else if (item == "攻略") {
        this.pageNmae = "StrategyPage";
      } else if (item == "视频") {
        this.pageNmae = "VideoPage";
      } else if (item == "图集") {
        this.pageNmae = "Atlas";
      }
      this.$router.push({
        name: this.pageNmae,
        params: {
          pinyin: this.pinyin,
          id: this.$route.params.id,
        },
      });
    },
  },
};
</script>
<style scoped>
.dlds {
  display: flex;
}
.dlds li {
  flex: 1;
}
</style>